/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Go_To_SettingsInputs */

const en_go_to_settings = /** @type {(inputs: Go_To_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to Settings`)
};

const es_go_to_settings = /** @type {(inputs: Go_To_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir a Configuración`)
};

const fr_go_to_settings = /** @type {(inputs: Go_To_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller aux paramètres`)
};

const de_go_to_settings = /** @type {(inputs: Go_To_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu den Einstellungen`)
};

const ja_go_to_settings = /** @type {(inputs: Go_To_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定へ進む`)
};

const zh_go_to_settings = /** @type {(inputs: Go_To_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前往设置`)
};

const ar_go_to_settings = /** @type {(inputs: Go_To_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الذهاب للإعدادات`)
};

const id_go_to_settings = /** @type {(inputs: Go_To_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka Pengaturan`)
};

const it_go_to_settings = /** @type {(inputs: Go_To_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai alle Impostazioni`)
};

const ru_go_to_settings = /** @type {(inputs: Go_To_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти в Настройки`)
};

const pt_go_to_settings = /** @type {(inputs: Go_To_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir para Configurações`)
};

const ko_go_to_settings = /** @type {(inputs: Go_To_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`설정으로 이동`)
};

/**
* | output |
* | --- |
* | "Go to Settings" |
*
* @param {Go_To_SettingsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const go_to_settings = /** @type {((inputs?: Go_To_SettingsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_To_SettingsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_go_to_settings(inputs)
	if (locale === "es") return es_go_to_settings(inputs)
	if (locale === "fr") return fr_go_to_settings(inputs)
	if (locale === "de") return de_go_to_settings(inputs)
	if (locale === "ja") return ja_go_to_settings(inputs)
	if (locale === "zh") return zh_go_to_settings(inputs)
	if (locale === "ar") return ar_go_to_settings(inputs)
	if (locale === "id") return id_go_to_settings(inputs)
	if (locale === "it") return it_go_to_settings(inputs)
	if (locale === "ru") return ru_go_to_settings(inputs)
	if (locale === "pt") return pt_go_to_settings(inputs)
	return ko_go_to_settings(inputs)
});